<form [formGroup]="instructorForm">
  <div class="form-row">
    <div class="col-md-12 m-b-20">
      <div class="row pt-lg-3">
        <div class="col-12 col-md-12 col-lg-12 col-sm-12">
          <h2 class="h2">{{translationScope+'.titles.select_courses' | transloco}}</h2>
        </div>
      </div>
    </div>
  </div>


  <div class="form-row">
    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit required">
        <label for="type-experience" class="text-uppercase">{{translationScope+'.form.offered_courses.label' | transloco}} </label>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10" *ngIf="isBrowser">
            <ng-select
              [readonly]="isTabReadOnly"
              [items]="courseTemplates$ | async"
              [multiple]="true"
              [closeOnSelect]="false"
              [hideSelected]="true"
              bindValue="id"
              bindLabel="title"
              (blur)="onSelectTemplate()"
              (remove)="onRemoveTemplate()"
              [placeholder]="translationScope+'.form.offered_courses.placeholder' | transloco"
              formControlName="courseTemplates">
            </ng-select>
            <span *ngIf="isInvalidateControl('courseTemplates', 'required')" class="form-control-error-message">
              {{translationScope+'.form.offered_courses.error.required' | transloco}}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit required">
        <label for="haveBoat" class="text-uppercase"> {{translationScope+'.form.boat_access.label' | transloco}} </label>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10" *ngIf="isBrowser">
            <ng-select [items]="haveAccess"
                bindValue="value"
                bindLabel="label"
                [clearable]="false"
                (change)="onSelectHavBoatAccess($event.value)"
                formControlName="haveBoat"
                [placeholder]="translationScope+'.form.boat_access.placeholder' | transloco" id="haveBoat">
              </ng-select>
            <span *ngIf="isInvalidateControl('haveBoat', 'required')" class="form-control-error-message" >{{translationScope+'.form.boat_access.error.required' | transloco}}</span>
          </div>
        </div>
      </div>
    </div>

    <ng-container formGroupName="boat">
      <div class="col-md-12">
        <div class="input-item-edit">
          <label for="type-experience" class="text-uppercase">{{translationScope+'.form.boat_type.label' | transloco}} </label>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-10">
              <textarea formControlName="type" class="form-control rounded-0"
                rows="5"
                [class.form-control-error]="isInvalidateControl('boat.type', 'required')" [placeholder]="translationScope+'.form.boat_type.placeholder' | transloco"></textarea>
              <span *ngIf="isInvalidateControl('boat.type', 'required')" class="form-control-error-message">{{translationScope+'.form.boat_type.error.required' | transloco}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit required">
        <label for="hasClassroomAccess" class="text-uppercase">{{translationScope+'.form.course_access.label' | transloco}} </label>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10" *ngIf="isBrowser">
            <ng-select [items]="haveAccess"
                bindValue="value"
                bindLabel="label"
                [clearable]="false"
                formControlName="hasClassroomAccess"
                [placeholder]="translationScope+'.form.course_access.placeholder' | transloco" id="hasClassroomAccess">
              </ng-select>
            <span *ngIf="isInvalidateControl('hasClassroomAccess', 'required')" class="form-control-error-message">{{translationScope+'.form.course_access.error.required' | transloco}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit">
        <div class="row mt-4">
          <div class="col-12 col-sm-12 col-md-10">
            <div class="custom-control custom-checkbox">
              <input
                formControlName="havePc"
                type="checkbox"
                name="havePc"
                class="custom-control-input"
                id="havePc"
                required
              />
              <label class="custom-control-label paragraph" for="havePc">
                {{translationScope+'.form.pc_access.label' | transloco}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 col-sm-12">
      <div class="input-item-edit">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10">
            <div class="custom-control custom-checkbox">
              <input
                [formControl]="notificationPreferenceFormControl"
                type="checkbox"
                name="notificationPreference"
                class="custom-control-input"
                id="notificationPreference"
                [readonly]="isTabReadOnly"
                (change)="setNotificationPreference()"
              />
              <label class="custom-control-label paragraph" for="notificationPreference">
                {{translationScope+'.form.notification_preference.label' | transloco}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Certificates -->
  <div class="form-row">
    <div class="col-12 col-sm-12 col-md-10">
      <div class="my-5">
        <h2 class="h2">{{translationScope+'.titles.upload_cv' | transloco}}<span style="color:#FF0000">*</span>{{translationScope+'.titles.and_certificates' | transloco}}</h2>
        <p class="paragraph">{{translationScope+'.instructions.my_courses.cv_and_certificates_upload' | transloco}}
          <a type="button" class="model-link font-weight-bold" (click)="openInstructorTemplatePage()"> {{translationScope+'.instructions.my_courses.instructor_template_page_link' | transloco}}</a> {{translationScope+'.instructions.my_courses.instructor_template_page_info_text' | transloco}}
        </p>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-10">

      <p class="paragraph my-3">{{translationScope+'.titles.attachments' | transloco}}</p>

      <ng-container *ngIf="instructor$ | async as instructor">
        <ng-container *ngIf="getCvOrCertificate(instructor.medias).length; else noCvOrCertificate">
          <div class="table-responsive">
            <table class="table">
              <tbody>
                <tr *ngFor="let file of getCvOrCertificate((instructor$ | async).medias), let i = index">
                  <ng-container *ngIf=" checkFileContentType(file) === 'NOT SUPPORTED'; else imagePreview">
                    <td>
                      <img (click)="openFilePreviwer(file)" src="/assets/images/default-thumbnail.png" alt="thumbnail" class="image-view">
                    </td>
                  </ng-container>

                  <ng-template #imagePreview>
                    <td>
                      <img (click)="openFilePreviwer(file)" [src]="file.url+'?w=120&h=100&auto=compress&fit=crop&crop=faces'" alt="thumbnail" class="image-view grab-cursor">
                    </td>
                  </ng-template>

                  <td> <a type="button"><i class="fas fa-paperclip"></i> {{file.name}}</a></td>
                  <td> <p class="text-capitalize paragraph">{{file.category}}</p></td>
                  <td>
                    <a (click)="removeCvOrCertificate(file.name)"
                       type="button"
                       [ngClass]="{ 'readonly': isTabReadOnly }"
                    >
                      <i class="fas fa-trash-alt" style="color: #F54336;"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </ng-container>

      <div *ngIf="!isTabReadOnly" class="upload-buttons">
        <div class="col-12 col-md-12">
          <button
            type="button"
            ngfSelect
            selectable
            [(file)]="instructorCv"
            accept="application/pdf,.docx,application/msword"
            [maxSize]="6e+6"
            [(lastInvalids)]="invalidFile"
            (lastInvalidsChange)="notifyInvalidType()"
            (fileChange)="uploadCv($event)"
            class="btn btn-primary">
            <img class="icon-plus">
            {{translationScope+'.action_buttons.upload_cv' | transloco}}
        </button>

        <button
          type="button"
          ngfSelect
          selectable
          [(file)]="instructorCertificate"
          accept="image/*,application/pdf,.docx,application/msword"
          [maxSize]="6e+6"
          [(lastInvalids)]="invalidFile"
          (lastInvalidsChange)="notifyInvalidType()"
          (fileChange)="uploadCertificate($event)"
          class="btn btn-primary">
          <img class="icon-plus">
          {{translationScope+'.action_buttons.upload_certificate' | transloco}}
        </button>
        </div>
      </div>

    </div>



    <!-- Terms and Conditions -->
    <div class="col-md-12 col-lg-12 col-sm-12 my-4">
      <div class="input-item-edit">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-10">
            <div class="custom-control custom-checkbox">
              <input
                formControlName="acceptTnC"
                type="checkbox"
                name="acceptTnC"
                class="custom-control-input"
                id="acceptTnC"
                required
              />
              <label class="custom-control-label paragraph" for="acceptTnC">
                {{translationScope+'.form.accept_terms_and_conditions.label' | transloco }}
                <a class="model-link" type="button" (click)="openTermsConditionPage()"><b>{{translationScope+'.terms_and_conditions' | transloco}}</b></a
                >
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isTabReadOnly" class="row btn-control-group mt-3">
    <div class="col-6 col-sm-12 col-md-6">
      <button (click)="backToBankInfo()" class="btn btn-success form-control rounded-0 text-uppercase">
      {{translationScope+'.action_buttons.back' | transloco}}
      </button>
    </div>

    <div class="col-6 col-sm-12 col-md-6">
      <button
        *ngIf="!isUpdate" (click)="formSubmit()"
        [disabled]="enableFormSubmit()"
        class="btn btn-success form-control rounded-0 text-uppercase">
        {{translationScope+'.action_buttons.send_request' | transloco}}
      </button>
      <button
        *ngIf="isUpdate" (click)="formSubmit(false)"
        [disabled]="enableFormSubmit()"
        class="btn btn-success form-control rounded-0 text-uppercase">
        {{translationScope+'.action_buttons.send_request' | transloco}}
      </button>
    </div>
  </div>

  <div *ngIf="!isTabReadOnly" class="row">
    <div class="col-md-12 col-12 col-lg-12 note" style="margin-top: 15px">
      <span class="text-danger">
       {{translationScope+'.instructions.my_courses.required_text' | transloco}}
      </span>
    </div>
  </div>
</form>

<ng-template #noCvOrCertificate>
  <div class="my-5 text-center">
    {{translationScope+'.instructions.my_courses.no_cv_and_certificates' | transloco}}
  </div>
</ng-template>
